// Phase 8 R2 — create canned job (always inactive draft per RPC).

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { toast } from '@/hooks/use-toast';

interface Vars {
  shopId: string;
  name: string;
  description?: string | null;
  category?: string | null;
}

export function useCreateCannedJob() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ shopId, name, description, category }: Vars): Promise<string> => {
      const { data, error } = await (supabase as any).rpc('create_canned_job', {
        p_shop_id: shopId,
        p_name: name,
        p_description: description ?? null,
        p_category: category ?? null,
        p_is_active: false,
      });
      if (error) throw error;
      return data as string;
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['canned-jobs-admin'] });
      toast({ title: 'Canned job created', description: 'Add lines, then activate it.' });
    },
    onError: (err: any) => {
      toast({
        title: 'Could not create canned job',
        description: err?.message ?? 'Unknown error',
        variant: 'destructive',
      });
    },
  });
}
